<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <!-- top toolbar START -->
        <v-toolbar flat>
          <v-icon class="mr-3">mdi-account</v-icon>
          <v-toolbar-title>Edit your Profile</v-toolbar-title>
        </v-toolbar>
        <!-- top toolbar END -->
      </v-col>
    </v-row>
    <!-- tabs START -->
    <v-row>
      <v-col cols="12">
        <v-tabs v-model="active" slider-color="pink">
          <v-tab v-for="(item, index) in tabs" :key="index">
            {{ item }}
          </v-tab>
          <v-tab v-if="this.$store.getters.user.admin">
            Admin
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="active">
          <!-- profile tab START -->
          <v-tab-item>
            <v-container fluid>
              <v-row>
                <v-col cols="12">
                  <span class="subheading"
                    >Your email address is your Himydata user name and what you
                    use to sign in. We will also use your email address to send
                    you important system status updates.</span
                  >
                </v-col>
              </v-row>
              <template>
                <form>
                  <!-- email field START -->
                  <v-text-field
                    label="Your E-mail address"
                    v-model="user.email"
                    disabled
                  ></v-text-field>
                  <!-- email field END -->

                  <!-- first name field START -->
                  <v-text-field
                    label="Your First Name"
                    v-model="user.firstName"
                    :error-messages="
                      errors ? errors.collect('first_name') : undefined
                    "
                    data-vv-name="first_name"
                  ></v-text-field>
                  <!-- first name field END -->

                  <!-- last name field START -->
                  <v-text-field
                    label="Your Last Name"
                    v-model="user.lastName"
                    :error-messages="
                      errors ? errors.collect('last_name') : undefined
                    "
                    data-vv-name="last_name"
                  ></v-text-field>
                  <!-- last name field END -->

                  <!-- update profile button START -->
                  <v-btn color="primary" large @click.native="changeName()"
                    >Update Profile</v-btn
                  >
                  <!-- update profile button END -->
                  <v-divider class="my-5"></v-divider>
                  <label class="">Do you wish to delete your account?</label>
                  <!-- delete account button START -->
                  <v-btn
                    color="error"
                    class="mx-5"
                    outlined
                    text
                    @click.native="dialog = true"
                    >Delete account</v-btn
                  >
                  <!-- delete account button END -->
                </form>
              </template>

              <!-- delete dialog START -->
              <v-dialog
                v-model="dialog"
                max-width="500px"
                transition="dialog-transition"
              >
                <v-card>
                  <v-card-title class="headline"
                    >Deleting your account</v-card-title
                  >
                  <v-card-text>
                    You are about to delete your account. You can retrieve the
                    account within 30 days by contacting our support. It will be
                    kept in our database for 30 days and will be destroyed after
                    that.
                    <v-checkbox
                      v-model="consentment"
                      label="I understand and accept the conditions"
                    ></v-checkbox>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click.native="dialog = false">Cancel</v-btn>
                    <v-btn @click.native="deactivateAccount()">delete</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <!-- delete dialog END -->
            </v-container>
          </v-tab-item>
          <!-- profile tab END -->

          <!-- password tab START -->
          <v-tab-item>
            <v-container fluid>
              <v-row>
                <v-col cols="12">
                  <span class="subheading"
                    >Note that you will continue to be logged in on any active
                    login sessions you have in other browser windows or clients.
                    Close or restart them in order for the change to fully take
                    effect.</span
                  >
                </v-col>
              </v-row>
              <template>
                <form>
                  <v-text-field
                    v-model="oldPassword"
                    :append-icon="showOldPassword ? 'mdi-eye-off' : 'mdi-eye'"
                    :type="showOldPassword ? 'text' : 'password'"
                    :error-messages="
                      errors ? errors.collect('old_password') : undefined
                    "
                    data-vv-name="old_password"
                    v-validate="'required'"
                    label="Enter your old password"
                    @click:append="showOldPassword = !showOldPassword"
                  ></v-text-field>

                  <password
                    v-model="newPassword1"
                    placeholder="Please enter a Password"
                    @score="showScore"
                  >
                  </password>
                  {{ passwordMessage }}

                  <v-text-field
                    v-model="newPassword2"
                    :append-icon="showNewPassword2 ? 'mdi-eye-off' : 'mdi-eye'"
                    :type="showNewPassword2 ? 'text' : 'password'"
                    :error-messages="
                      errors ? errors.collect('new_password2') : undefined
                    "
                    data-vv-name="new_password2"
                    v-validate="'required|min:8'"
                    label="Confirm your new password"
                    @click:append="showNewPassword2 = !showNewPassword2"
                  ></v-text-field>
                  <v-btn
                    class="mt-5"
                    large
                    color="primary"
                    @click.native="
                      changePassword(oldPassword, newPassword1, newPassword2)
                    "
                    >Change Password</v-btn
                  >
                </form>
              </template>
            </v-container>
          </v-tab-item>
          <!-- password tab START -->
          <!-- api keys tab START -->
          <v-tab-item>
            <v-container fluid>
              <v-row>
                <v-col cols="2" class="mx-2">
                  <label class="subheading font-weight-medium">User Key</label>
                </v-col>
              </v-row>
              <v-row>
                <v-col xs="12" class="ma-2">
                  <span>{{ user.key }}</span>
                </v-col>
                <v-col xs="12">
                  <v-btn class="ma-2" @click="doCopy(user.key)"
                    >copy to clipboard</v-btn
                  >
                  <v-btn class="ma-2" @click.native="generateApiKeys()"
                    >Regenerate</v-btn
                  >
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
          <!-- api keys tab END -->
          <!-- Admin tab START -->
          <v-tab-item>
            <v-container fluid>
              <v-row>
                <v-col
                  cols="4"
                  v-for="item in adminTitles"
                  :key="item.title"
                  class="subheading font-weight-medium "
                >
                  {{ item.title }}</v-col
                >
              </v-row>
              <v-row no-gutters>
                <v-col cols="12">
                  <!--          <span> {{ $store.getters.baseUrl.name }}</span> -->
                  <v-list>
                    <v-list-item
                      v-for="(item, i) in listAdminSites"
                      :key="i"
                      class="mb-5"
                    >
                      <v-row class="displayProject d-flex align-center">
                        <v-col cols="4" class="text-body-1 font-weight-medium"
                          >{{ item.name }}
                        </v-col>
                        <v-col cols="4" class="text-body-1 font-weight-medium">
                          <v-chip
                            :color="
                              selectedBaseUrl == item.name
                                ? 'accent'
                                : 'transparent'
                            "
                          >
                            {{ item.domain }}
                          </v-chip>
                        </v-col>
                        <v-col cols="4" class=" d-flex justify-end ">
                          <AdminDialog
                            :site="item"
                            @selectedUrl="getSelectedUrl"
                          />
                        </v-col>
                      </v-row>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
          <!-- Admin tab END -->
        </v-tabs-items>
      </v-col>
    </v-row>
    <!-- tabs END -->
  </v-container>
</template>

<script>
import SettingsService from "./services/SettingsService";
import Password from "vue-password-strength-meter";
import AdminDialog from "./components/AdminDialog.vue";

export default {
  components: {
    Password,
    AdminDialog
  },
  data: function() {
    return {
      adminTitles: [{ title: "Name" }, { title: "Domain" }],
      selectedBaseUrl: "",
      tabs: ["profile", "password", "API keys"],
      listAdminSites: [],
      columns: [
        { text: "ip address", value: "ip_address", align: "center" },
        { text: "user agent", value: "user_agent", align: "center" }
      ],
      user: {
        email: "",
        key: "",
        firstName: "",
        lastName: "",
        username: ""
      },
      active: 0,
      oldPassword: "",
      showOldPassword: false,
      newPassword1: "",
      showNewPassword1: false,
      newPassword2: "",
      showNewPassword2: false,
      dialog: false,
      consentment: false,
      passwordStrength: 0,
      passwordMessage: ""
    };
  },
  mounted() {
    var t = this;

    if (localStorage.getItem("baseUrl")) {
      const url = JSON.parse(localStorage.getItem("baseUrl"));
      this.selectedBaseUrl = url.name;
    }

    SettingsService.get_profile()
      .then(function(response) {
        t.user.email = response.data.email;
        t.user.firstName = response.data.first_name;
        t.user.lastName = response.data.last_name;
        t.user.username = response.data.username;
      })
      .catch(function(error) {
        t.$store.commit("push", { msg: error.response.data, color: "error" });
      });
    this.getApiKeys();
    this.getListAdminSites();
  },

  methods: {
    getListAdminSites() {
      SettingsService.getListAdminSite().then(r => {
        this.listAdminSites = r.data.results;
      });
    },

    getSelectedUrl(value) {
      this.selectedBaseUrl = value.name;
    },
    doCopy: function(txt) {
      window.prompt("Copy to clipboard: Ctrl+C, Enter", txt);
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    changeName() {
      SettingsService.changeName(
        this.user.firstName,
        this.user.lastName,
        this.user.username,
        this
      );
    },
    changePassword(old, new1, new2) {
      SettingsService.changePassword(old, new1, new2, this);
    },
    generateApiKeys() {
      var t = this;
      SettingsService.generate_api_keys()
        .then(function(response) {
          t.$store.commit("push", {
            msg: "token succesfully regenerated",
            color: "success"
          });
          t.user.key = response.data.token;
          localStorage.setItem("token", response.data.token);
        })
        .catch(function(error) {
          t.$store.commit("push", { msg: error.response.data, color: "error" });
        });
    },
    getApiKeys() {
      var t = this;
      SettingsService.get_api_keys()
        .then(function(response) {
          t.user.key = response.data.token;
        })
        .catch(function(error) {
          t.$store.commit("push", { msg: error.response.data, color: "error" });
        });
    },
    deactivateAccount() {
      var t = this;
      if (this.consentment) {
        SettingsService.deactivateAccount()
          .then(function(response) {
            t.$store.commit("push", {
              msg: response.data.msg,
              color: "success"
            });
          })
          .catch(function(error) {
            t.$store.commit("push", {
              msg: error.data.response,
              color: "error"
            });
          });
      }
    },
    showScore(score) {
      this.passwordStrength = score;
      switch (score) {
        case 0:
          this.passwordMessage = "You know it's not good enough";
          break;
        case 1:
          this.passwordMessage = "You can do better than this";
          break;
        case 2:
          this.passwordMessage = "Just one more effort";
          break;
        case 3:
          this.passwordMessage = "Now we're good";
          break;
        case 4:
          this.passwordMessage =
            "Okay but make sure you remember that password!";
          break;
      }
    }
  }
};
</script>
<style>
.Password {
  max-width: 100% !important;
}
</style>
